import { EFFORT_MESSAGES } from '#pplx/frontend/apps/ask/search-models-menu/ComputerEffortMenuItemsShared.js';
import { messages as presetMessages } from '#pplx/frontend/apps/ask/search-models-menu/ComputerPresetsMenuShared.js';
import { HarnessMode } from '#pplx/frontend/apps/ask/search-models-menu/ComputerPresetsShared.js';
import { parseDeepResearchReasoningEffort } from '#pplx/frontend/ask-models/reasoningEffort.js';
import { useObjectFlagValue } from '#pplx/frontend/experimentation/hooks.js';
import { useIntl } from 'react-intl';
const DEFAULT_DR_CONFIG = {};
// Select the matching visual level, while retaining the exact reasoning-effort label.
const EFFORT_ICON_LEVEL = {
    none: HarnessMode.LIGHT,
    minimal: HarnessMode.LIGHT,
    low: HarnessMode.LIGHT,
    medium: HarnessMode.STANDARD,
    high: HarnessMode.HIGH,
    xhigh: HarnessMode.ULTRA,
    max: HarnessMode.ULTRA,
};
export function useAskDeepResearchModelSelectorOverrides({ enabled, activeEffort = null, }) {
    const { $t } = useIntl();
    const { variation } = useObjectFlagValue({
        flag: 'ask-deep-research-computer-config',
        defaultValue: DEFAULT_DR_CONFIG,
        skip: !enabled || activeEffort !== null,
    });
    if (!enabled)
        return undefined;
    const effort = activeEffort ?? parseDeepResearchReasoningEffort(variation);
    return {
        disabled: true,
        computerEffortEnabled: true,
        computerEffortPreferences: {
            version: 1,
            harness_mode: effort ? EFFORT_ICON_LEVEL[effort] : HarnessMode.STANDARD,
        },
        computerEffortLabel: effort ? $t(EFFORT_MESSAGES[effort]) : $t(presetMessages.default),
    };
}
//# sourceMappingURL=useAskDeepResearchModelSelectorOverrides.js.map